
import { useNavigate } from 'react-router-dom';

import '../styles/EmployeeMaster.css';
import CasteTable from '../components/CasteTable';

const Caste = () => {
     const navigate = useNavigate();

     const handleAddClick = () => {

          navigate('/caste/add');
     };



     return (
          <div className="employee-master-page">
               <div className="employee-header">
                    <h2>Caste Master</h2>
                    <button className="add-employee-btn" onClick={handleAddClick}>
                         Add Caste
                    </button>
               </div>

               <CasteTable />
          </div>
     );
};

export default Caste;